//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Creates and returns question.
 */
export function createQuestion(dto: Types.QuestionCreationDto, config?: AxiosRequestConfig | undefined): Promise<Types.SurveyQuestion | null> {
    let url_ = getBaseUrl() + "/api/questionScheme/question";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateQuestion,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateQuestion(_response);
    });
}

function processCreateQuestion(response: AxiosResponse): Promise<Types.SurveyQuestion | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = resultData400 ? Types.ValidationProblemDetails.fromJS(resultData400) : <any>null;
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = resultData200 ? Types.SurveyQuestion.fromJS(resultData200) : <any>null;
        return Promise.resolve<Types.SurveyQuestion | null>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = resultData201 ? Types.SurveyQuestion.fromJS(resultData201) : <any>null;
        return Promise.resolve<Types.SurveyQuestion | null>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SurveyQuestion | null>(null as any);
}
let _requestConfigCreateQuestion: Partial<AxiosRequestConfig> | null;
export function getCreateQuestionRequestConfig() {
  return _requestConfigCreateQuestion;
}
export function setCreateQuestionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateQuestion = value;
}
export function patchCreateQuestionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateQuestion = patch(_requestConfigCreateQuestion ?? {});
}